module.exports = __webpack_public_path__ + "static/media/man_rounded_photo.a357c659.png";